import {
    UnauthenticatedGlobalContext,
    UnauthenticatedGlobalContextValue
} from '~/providers/unauthenticated-global-context/unauthenticated-global.context';
import { useGlobal } from '~/providers/global.provider';

export function useUnauthenticatedGlobal(): UnauthenticatedGlobalContextValue {
    return useGlobal<UnauthenticatedGlobalContext>(
        UnauthenticatedGlobalContext
    );
}
